import React from 'react';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <div className="container">
        <div className="page-header">
          <h1>Privacy Policy</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>
        </div>
        
        <div className="privacy-content">
          <section>
            <h2>Information We Collect</h2>
            <p>We collect information you provide directly to us through contact forms, emails, and communications.</p>
          </section>
          
          <section>
            <h2>How We Use Your Information</h2>
            <p>We use your information to respond to inquiries, provide support, and improve our services.</p>
          </section>
          
          <section>
            <h2>Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal information. Contact us at info@programmoceuticals.com.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;